/**
 * This is not an SFC because we need to be able to overwrite spriteUrl prop default value
 * This alows us to inline the SVG for login/signup pages
 */
export default {
    name: 'pu-icon',
    props: {
        icon: { required: true, type: String },
        size: { required: false, type: Number, default: 20 },
        spriteUrl: { required: false, type: String, default: '/icons/icons.svg' },
    },
    render(createElement) {
        return createElement(
            'span',
            {
                class: ['pu-icon'],
                style: this.elStyle,
            },
            [
                createElement(
                    'svg',
                    {
                        class: `icon-${this.icon}`,
                        attrs: {
                            'aria-hidden': true,
                        },
                    },
                    [
                        createElement('use', {
                            attrs: {
                                'xlink:href': `${this.spriteUrl}#${this.icon}`,
                            },
                        }),
                    ]
                ),
            ]
        );
    },
    data() {
        return {};
    },
    computed: {
        elStyle() {
            return {
                'font-size': `${this.size}px`,
            };
        },
    },
};
